import { useCallback, useEffect, useState } from 'react';
import * as React from 'react';
import styled from 'styled-components';

import { MagicButton } from './MagicButton';
import { MagicPopover } from './MagicPopover';
import { type MagicElementState } from './sharedStyles';

const Wrapper = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 2px;
`;

interface MagicElementProps {
  popupOverride?: boolean;
  state?: MagicElementState;
  stillThinking?: boolean;
}

export const MagicElement: React.ComponentType<MagicElementProps> = React.memo(
  function MagicElement({
    state = 'default',
    stillThinking = false,
    popupOverride
  }) {
    const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);

    useEffect(() => {
      if (popupOverride !== undefined) {
        setIsPopoverOpen(popupOverride);
      }
    }, [popupOverride]);

    const _togglePopover = useCallback(() => {
      if (popupOverride === undefined) {
        setIsPopoverOpen(prev => !prev);
      }
    }, [popupOverride]);

    return (
      <Wrapper>
        <MagicButton
          state={isPopoverOpen ? 'active' : state}
          stillThinking={stillThinking}
          onClick={_togglePopover}
        />
        <MagicPopover isOpen={isPopoverOpen} />
      </Wrapper>
    );
  }
);
